import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Insurance(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M5 7a3 3 0 013-3h8a3 3 0 013 3v5.636c-.313 2.678-2.038 4.513-3.817 5.719A14.023 14.023 0 0112 19.95a14.022 14.022 0 01-3.183-1.595C7.038 17.149 5.313 15.315 5 12.636V7zm6.726 14.962L12 21l-.273.962c.178.05.367.05.546 0L12 21l.274.962.003-.001.007-.002.022-.007a9.928 9.928 0 00.334-.108 16.011 16.011 0 003.666-1.834c2.039-1.382 4.302-3.685 4.688-7.209.004-.036.006-.072.006-.109V7a5 5 0 00-5-5H8a5 5 0 00-5 5v5.692c0 .037.002.073.006.11.386 3.523 2.649 5.826 4.689 7.208a16.012 16.012 0 003.665 1.835 9.928 9.928 0 00.334.107l.022.007.007.002h.003zm4.981-11.255a1 1 0 00-1.414-1.414L11 13.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l5-5z",
    clipRule: "evenodd"
  }));
}

export default Insurance;